import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const initState = {
    tableTotal: 0,
    pageSize: 20,
    pageIndex: 1,
    TableData: [],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        updateTable(params, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { searchData, pageIndex } = state;
                const searchParams = Object.assign(Object.assign({}, searchData), { pageIndex });
                console.log('搜索参数', searchParams);
                const tableData = [
                    {
                        carStyle: '21',
                        key: '1',
                    },
                    {
                        carStyle: '22',
                        key: '2',
                    },
                    {
                        carStyle: '23',
                        key: '3',
                    },
                ];
                this.SET_STATE({
                    tableData,
                });
            });
        },
        // 跳转详情
        toDetail(playload) {
            const { id } = playload;
            const path = '/System/argueRules/detail';
            const query = { id };
            dispatch.router.push({ path, query });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign({}, initState));
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
